<template>
  <div ref="chart" class="chart"></div>
</template>
<script>
let echarts = require('echarts/lib/echarts')
export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  watch: {
    options: {
      handler () {
        this.refresh()
      },
      deep: true
    }
  },
  data () {
    return {
      chart: null,
      resizeHandler: null
    }
  },
  methods: {
    // 初始化
    draw () {
      let dom = this.$refs.chart
      this.chart = echarts.init(dom)
      this.chart.setOption(this.options)

      // 监听并上报图表事件
      this.chart.on('mouseover', param => {
        this.$emit('over', param)
      })
      this.chart.on('mouseout', param => {
        this.$emit('out', param)
      })
      this.chart.on('click', param => {
        this.$emit('click', param)
      })

      // 窗口尺寸变化时自适应
      this.resizeHandler = () => {
        this.chart.resize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    // 数据更新
    refresh () {
      this.chart && this.chart.setOption(this.options)
    }
  },
  mounted () {
    this.draw()
  },
  beforeDestroy () {
    // 移除自适应监听
    window.removeEventListener('resize', this.resizeHandler)
    this.resizeHandler = null
  },
}
</script>
<style lang="less" scoped>
</style>
